module.exports = __webpack_public_path__ + "media/images/slide-7-bc2235b61fd9cdec930e3c7a5e7d2ca5.jpg";